import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=19e1a502&scoped=true"
import script from "./EntityView.vue?vue&type=script&lang=ts"
export * from "./EntityView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1a502",
  null
  
)

export default component.exports